export function getTotalFrames(animationDuration: number, fps: number): number {
  return Math.max(1, Math.round(animationDuration * fps));
}

export function secondsToFrames(seconds: number, fps: number): number {
  return Math.max(1, Math.round(seconds * fps));
}

export function frameToPercent(frame: number, totalFrames: number): number {
  if (totalFrames <= 0) return 0;
  return Math.min(1, Math.max(0, frame / totalFrames));
}

export function percentToFrame(percent: number, totalFrames: number): number {
  if (totalFrames <= 0) return 0;
  return Math.round(Math.min(1, Math.max(0, percent)) * totalFrames);
}

export function frameToPixel(frame: number, trackWidth: number, totalFrames: number): number {
  if (trackWidth <= 0 || totalFrames <= 0) return 0;
  return frameToPercent(frame, totalFrames) * trackWidth;
}

export function pixelToFrame(pixel: number, trackWidth: number, totalFrames: number): number {
  if (trackWidth <= 0 || totalFrames <= 0) return 0;
  const clamped = Math.min(trackWidth, Math.max(0, pixel));
  return percentToFrame(clamped / trackWidth, totalFrames);
}

export function frameToTimeLabel(frame: number, fps: number): string {
  const totalSeconds = frame / Math.max(1, fps);
  return `${totalSeconds.toFixed(2)}s`;
}
